import { render, staticRenderFns, recyclableRender, components } from "./peng-tree.vue?vue&type=template&id=43d2b1f8&scoped=true&xlang=wxml&"
var renderjs
import script from "./peng-tree.vue?vue&type=script&lang=js&"
export * from "./peng-tree.vue?vue&type=script&lang=js&"
import style0 from "./peng-tree.vue?vue&type=style&index=0&id=43d2b1f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d2b1f8",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "uni_modules/peng-tree/peng-tree/peng-tree.vue"
export default component.exports